import { defineNuxtRouteMiddleware } from "#imports";
import { usePageStore } from "@voix/store/pageStore";
export default defineNuxtRouteMiddleware((to, from) => {
  if (from.name !== "voix-studio-en")
    return;
  const pageStore = usePageStore();
  if (pageStore.currentPageIsDirty === false) {
    return;
  }
  return confirm("You have some unsaved changes. Are you sure you want to leave?");
});
